import React from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const comparisonTable = [{
  sit: 'Terminás los 21 días y no sabés qué hacer',
  sin: 'Volvés al punto cero en una semana',
  con: 'Plan de 365 días estructurado'
}, {
  sit: 'Querés ir al asado sin arruinar todo',
  sin: 'Evitás salir o comes de más',
  con: 'Protocolo social de nivel experto'
}, {
  sit: 'El peso se estanca en la semana 3',
  sin: 'No sabés por qué ni cómo romperlo',
  con: 'Sistema de refeed estratégico'
}, {
  sit: 'Querés entrenar sin perder músculo',
  sin: 'Tenés miedo de no rendir',
  con: 'Protocolo de entrenamiento en cetosis'
}, {
  sit: 'Tenés estrés y los antojos vuelven',
  sin: 'Cedés y te sentís culpable',
  con: 'Gestión de cortisol documentada'
}];
const masterProFeatures = ['Sistema de ayuno intermitente avanzado', 'Refeeds estratégicos', 'Suplementación real en Argentina', 'Biohacking keto argentino', 'Optimización hormonal natural', 'Keto social nivel experto', 'Repostería gourmet para eventos', 'Plan de 365 días'];
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 bg-[#F5F1E8]" data-id="element-68">
      <div className="max-w-6xl mx-auto px-4" data-id="element-69">
        {/* Urgency */}
        <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16" data-id="element-70">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-50 text-red-600 font-bold text-sm mb-8 border border-red-200" data-id="element-71">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-72" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <CountdownTimer data-id="element-73" />

          <p className="text-lg md:text-xl text-slate-700 mt-8 mb-6" data-id="element-74">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-white border border-green-100 rounded-xl p-4 shadow-sm" data-id="element-75">
            <div className="text-sm font-bold text-red-600 flex items-center gap-2 mb-2" data-id="element-76">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-77" />
              Cupos al precio de lanzamiento — Quedan pocos
            </div>
            <div className="w-full bg-green-100 rounded-full h-3 overflow-hidden mb-1" data-id="element-78">
              <div className="bg-gradient-to-r from-red-600 to-red-500 h-3 rounded-full" style={{
              width: '68%'
            }} data-id="element-79" />
            </div>
            <div className="text-xs text-slate-500 text-right" data-id="element-80">
              68% ya tomados
            </div>
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-green-900 text-center mb-10 md:mb-16" data-id="element-81">
          ELEGÍ TU MEGA PACK
        </h2>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto mb-20 md:mb-24" data-id="element-82">
          {/* Card 1 */}
          <div className="bg-white border border-green-200 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col shadow-md" data-id="element-83">
            <div className="text-4xl mb-4" data-id="element-84">🥩</div>
            <h3 className="text-xl md:text-2xl font-bold text-green-900 mb-2" data-id="element-85">
              MEGA PACK CETOSIS EXTREMA 21 DÍAS
            </h3>
            <p className="text-green-600 font-medium mb-5 text-sm md:text-base" data-id="element-86">
              6 Tomos + 6 Bonos
            </p>
            <div className="bg-green-50 rounded-xl p-4 mb-6 border border-green-100" data-id="element-87">
              <span className="text-slate-600 text-xs block mb-1" data-id="element-88">
                Ideal para:
              </span>
              <span className="text-green-900 font-medium text-sm" data-id="element-89">
                Quien quiere bajar de peso con keto argentino real
              </span>
            </div>
            <div className="mb-6" data-id="element-90">
              <div className="text-slate-500 line-through text-lg" data-id="element-91">$51.000</div>
              <div className="text-4xl md:text-5xl font-bold text-green-900" data-id="element-92">
                $19.990
              </div>
            </div>
            <a href="#pricing" className="w-full py-4 rounded-xl bg-green-100 hover:bg-green-200 text-green-900 font-bold text-base md:text-lg transition-colors mt-auto border border-green-200 text-center block" data-id="element-93">
              → QUIERO MI MEGA PACK AHORA
            </a>
          </div>

          {/* Card 2 - Highlighted */}
          <div className="bg-gradient-to-b from-white to-green-50 border-2 border-green-500 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col relative shadow-lg" style={{
          boxShadow: '0 0 60px -15px rgba(34,197,94,0.3)'
        }} data-id="element-94">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-amber-500 text-white font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wide" data-id="element-95">
              MÁS ELEGIDO
            </div>
            <div className="text-4xl mb-4" data-id="element-96">🔥</div>
            <h3 className="text-xl md:text-2xl font-bold text-green-900 mb-2" data-id="element-97">
              MEGA PACK + KETO MÁSTER PRO ⭐
            </h3>
            <p className="text-green-600 font-medium mb-5 text-sm md:text-base" data-id="element-98">
              6 Tomos + 6 Bonos + Sistema de Optimización Permanente
            </p>
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6" data-id="element-99">
              <span className="text-amber-700 text-xs block mb-1" data-id="element-100">
                Ideal para:
              </span>
              <span className="text-green-900 font-medium text-sm" data-id="element-101">
                Quien quiere resultados permanentes y nunca más volver al punto
                cero
              </span>
            </div>
            <div className="mb-6" data-id="element-102">
              <div className="text-slate-500 line-through text-lg" data-id="element-103">$69.000</div>
              <div className="text-4xl md:text-5xl font-bold text-green-900" data-id="element-104">
                $27.990
              </div>
            </div>
            <a href="#pricing" className="animate-pulse-glow w-full py-4 rounded-xl bg-green-600 hover:bg-green-500 text-white font-bold text-base md:text-lg transition-all active:scale-95 mt-auto text-center block shadow-lg" data-id="element-105">
              → QUIERO EL MEGA PACK + KETO MÁSTER PRO
            </a>
          </div>
        </div>

        {/* Comparison */}
        <div className="max-w-5xl mx-auto" data-id="element-106">
          <h3 className="text-2xl md:text-4xl font-bold text-green-900 text-center mb-10 md:mb-12" data-id="element-107">
            🏆 ¿QUÉ AGREGA EL KETO MÁSTER PRO?
          </h3>

          <div className="bg-white border border-green-100 rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-12 shadow-md" data-id="element-108">
            <div className="overflow-x-auto" data-id="element-109">
              <table className="w-full text-left min-w-[700px]" data-id="element-110">
                <thead data-id="element-111">
                  <tr className="bg-green-50" data-id="element-112">
                    <th className="p-4 md:p-6 text-slate-700 font-semibold text-sm border-b border-green-200 w-1/3" data-id="element-113">
                      Situación real
                    </th>
                    <th className="p-4 md:p-6 text-red-600 font-semibold text-sm border-b border-green-200 w-1/3" data-id="element-114">
                      ❌ Sin Keto Máster Pro
                    </th>
                    <th className="p-4 md:p-6 text-green-600 font-semibold text-sm border-b border-green-200 w-1/3" data-id="element-115">
                      ✅ Con Keto Máster Pro
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-116">
                  {comparisonTable.map((row, i) => <tr key={i} className="border-b border-green-100 hover:bg-green-50/50 transition-colors" data-id="element-117">
                      <td className="p-4 md:p-6 text-green-900 font-medium text-sm" data-id="element-118">
                        {row.sit}
                      </td>
                      <td className="p-4 md:p-6 text-slate-600 text-sm" data-id="element-119">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-green-700 font-medium text-sm" data-id="element-120">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-121">
            <h4 className="text-xl md:text-2xl font-bold text-green-900 mb-6 md:mb-8 text-center" data-id="element-122">
              ✅ EL KETO MÁSTER PRO INCLUYE:
            </h4>
            <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-123">
              {masterProFeatures.map((f, i) => <div key={i} className="flex items-start gap-3" data-id="element-124">
                  <span className="text-green-600 mt-0.5 shrink-0" data-id="element-125">✅</span>
                  <span className="text-slate-700 font-medium text-sm md:text-base" data-id="element-126">
                    {f}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}